import { Avatar, Stack, Text, Tooltip } from '@chakra-ui/react'

import AnonymousPlaceholder from './AnonymousPlaceholder'
import {
  MARK_STYLES,
  hasHighlight as checkHighlight,
} from '../../constants/highlightConfig'
import { sanitizeHighlight } from '../../utils'

const Person = ({ link, name, highlightedName, hideAvatar, deactivated }) => {
  const hasHighlight = checkHighlight(highlightedName)

  const displayName = hasHighlight
    ? sanitizeHighlight(highlightedName) + (deactivated ? ' (Deactivated)' : '')
    : name + (deactivated ? ' (Deactivated)' : '')

  return (
    <Tooltip
      label={link ? 'Click to open profile in new tab' : ''}
      placement='bottom-start'
      openDelay={200}
    >
      <Stack
        direction='row'
        align='center'
        sx={{ userSelect: 'none' }}
        _hover={
          link
            ? {
                cursor: 'pointer',
                textShadow: '0px 0px 1px currentColor',
              }
            : undefined
        }
        onClick={e => {
          e.stopPropagation()
          if (link) window.open(link, '_blank')
        }}
      >
        {!hideAvatar && <Avatar name={name} size='sm' />}
        {displayName || name ? (
          hasHighlight ? (
            <Text
              align='center'
              dangerouslySetInnerHTML={{ __html: displayName }}
              sx={MARK_STYLES}
            />
          ) : (
            <Text align='center'>{displayName}</Text>
          )
        ) : (
          <AnonymousPlaceholder />
        )}
      </Stack>
    </Tooltip>
  )
}
export default Person
